import React from 'react';
import Banner from './banner/Banner';
import Intro from './intro/Intro';
import WishList from './whish-list/WishList';
import MessageUs from './message-us/MessageUs';
import FinancialHelp from './financial-help/FinancialHelp';
import Footer from './footer/Footer';
import LanguageSelector from './language-selector/LanguageSelector';

const MainPage = () => {
   return (
      <div className='max-width'>
         <LanguageSelector />
         <Banner />
         <Intro />
         <WishList />
         <FinancialHelp />
         <MessageUs />
         <Footer />
      </div>
   )
}

export default MainPage
